<div class="modal-header">
  <h3 class="modal-title">{{ titleModal }}</h3>
  <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body scroll-dark-active activity">
  <form [formGroup]="feeForm" (ngSubmit)="add()">
    <input type="hidden" formControlName="id">
    <div class="form-group">
      <label class="text-form">Tipo
        @if (feeForm.controls['type'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <select class="form-control" name="idsType" data-cy="select-simple" formControlName="type">
        <option value="">Seleccionar</option>
        @for (opt of listType; track opt) {
          <option [value]="opt.id">
            {{ opt.name }}
          </option>
        }
      </select>
    </div>
    <div class="form-group">
      <label class="text-form">Moneda
        @if (feeForm.controls['currency'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <select class="form-control" name="idsCurrency" data-cy="select-simple" formControlName="currency">
        <option value="">Seleccionar</option>
        @for (opt of listCurrency; track opt) {
          <option [value]="opt.id">
            {{ opt.name }}
          </option>
        }
      </select>
    </div>
    <div class="form-group">
      <label class="text-form">Cantidad
        @if (feeForm.controls['amount'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <input type="text" class="form-control style-asunto" formControlName="amount" currencyDirective
        [ngClass]="{ 'is-invalid':feeForm.controls['amount'].errors && feeForm.controls.name.touched}">
      @if (feeForm.controls['amount'].errors && feeForm.controls.name.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @if (feeForm.get('amount').hasError(validation.type) ) {
            <div class="error-message">
              El monto es requerido.
            </div>
          }
          @if (feeForm.controls['amount'].errors?.pattern) {
            <div class="error-message">
              El formato no es válido
            </div>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label class="text-form">Fecha Vcto.
        @if (feeForm.controls['expirationDate'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <div class="input-group style-button">
        <input class="form-control " placeholder="dd/mm/yyyy" formControlName="expirationDate" value="valor"
          name="expirationDate" data-cy="date" ngbDatepicker #dp="ngbDatepicker">
        <div class="input-group-append style-button">
          <button class="btn fas fa-calendar-alt bt" (click)="dp.toggle()" type="button"></button>
        </div>
      </div>
      @if (feeForm.controls['expirationDate'].errors && feeForm.controls.name.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @if (feeForm.get('expirationDate').hasError(validation.type) ) {
            <div class="error-message">
              La fecha es requerida.
            </div>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label class="text-form">Estado
        @if (feeForm.controls['status'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <select class="form-control" name="idsStatus" data-cy="select-simple" formControlName="status" placeholder="Seleccionar">
        <option value="">Seleccionar</option>
        @for (opt of listStatus; track opt) {
          <option [value]="opt.id">
            {{ opt.name }}
          </option>
        }
      </select>
    </div>
    <div class="form-group">
      <label class="text-form">Descripción
        @if (feeForm.controls['name'].errors?.required) {
          <span class="text-danger">&#10033;</span>
        }
      </label>
      <input type="text" class="form-control style-asunto" formControlName="name"
        [ngClass]="{ 'is-invalid':feeForm.controls['name'].errors && feeForm.controls.name.touched}">
      @if (feeForm.controls['name'].errors && feeForm.controls.name.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @if (feeForm.get('name').hasError(validation.type) ) {
            <div class="error-message">
              La Descripción es requerida.
            </div>
          }
        </small>
      }
    </div>

    <div class="form-group">
      <label class="text-form">Colaborador </label>
      <select formControlName="collaboratorId" placeholder="Seleccione colaborador" class="form-control">
        <option value="">Seleccionar</option>
        @for (collaborator of collaborators; track collaborator) {
          <option [value]="collaborator.id">
            {{ collaborator.text }}
          </option>
        }
      </select>
      @if (feeForm.controls.collaboratorId.errors && feeForm.controls.collaboratorId.touched) {
        <small class="form-text text-muted danger"
          class="invalid-feedback">
          @for (validation of activities_validation_messages.idsCollaborators; track validation) {
            <div>
              @if (feeForm.get('collaboratorId').hasError(validation.type) ) {
                <div class="error-message">
                  {{validation.message}}
                </div>
              }
            </div>
          }
        </small>
      }
    </div>
    <!--upload file section-->
    <div class="form-group upload-content">
      @if (temporaryfiles.length==0 && (!costArray || !costArray.url)) {
        <div class="d-flex align-items-center"
          (click)="preFileUpload()">
          <div class="icon-plus"><a class="icon-doc" data-cy="upload-file" type="button"><i
          class="fas fa-upload"></i></a></div>
          <label class="text-form mb-0 ml-2 attachment">Adjuntar documento</label>
        </div>
      }
      @if (temporaryfiles.length>0 && (!costArray || !costArray.url)) {
        <div>
          <label class="text-form mb-0">Documento</label><br>
          <div class="d-flex align-items-center">
            <label class="mb-0">{{temporaryfiles[0].name}}</label>
            <div class="icon-plus ml-3" (click)="deleteFile()"><a class="icon-doc" data-cy="upload-file"
              type="button"><i class="fas fa-trash"></i></a></div>
            </div>
          </div>
        }
        @if (costArray && costArray.url) {
          <div>
            <label class="text-form mb-0">Documento</label><br>
            <div class="d-flex align-items-center">
              <label class="mb-0">{{costArray.filename}}</label>
              <div class="icon-plus ml-3"><a [href]="costArray.url" class="icon-doc" data-cy="upload-file"
                type="button"><i class="fas fa-download"></i></a></div>
                <div class="icon-plus ml-3" (click)="deleteFile(costArray.id)"><a class="icon-doc"
                  data-cy="upload-file" type="button"><i class="fas fa-trash"></i></a></div>
                </div>
              </div>
            }

            <input #inputFile type="file" style="visibility: hidden;" (change)="fileUploadChange($event)">
          </div>
          <!-- Message Success Activity -->
          @if (successMessageActivity) {
            <div class="form-group">
              <div class="row">
                <div class="col-md-12">
                  <ngb-alert class="mt-3" type="success" (close)="successMessageActivity = ''">
                    {{ successMessageActivity }}
                  </ngb-alert>
                </div>
              </div>
            </div>
          }
          <!-- Message Error Activity -->
          @if (errorMessageActivity) {
            <div class="form-group">
              <div class="row">
                <div class="col-md-12">
                  <ngb-alert class="mt-3" type="danger" (close)="errorMessageActivity = ''">
                    {{ errorMessageActivity }}
                  </ngb-alert>
                </div>
              </div>
            </div>
          }
          <div class="line_horizontal_container">
            <div class="line_horizontal"></div>
          </div>

          <div class="form-group mt-3">
            <div class="row">
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold"
                  style="width: 120px;" (click)="activeModal.close('Close click')">
                  Cerrar
                </button>
                <button type="submit" class="btn btn-outline-primary  rounded-pill font-weight-bold mr-2"
                  style="width: 120px;" [disabled]="!submitted  && feeForm.invalid">
                  @if (submitted && feeForm.valid) {
                    <div>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Cargando...
                    </div>
                  }
                  @if (!submitted) {
                    <span>
                      {{ isEdit ? 'Guardar':'Crear' }}
                    </span>
                  }
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>